// removed by extract-text-webpack-plugin
module.exports = {"header-main":"_2qoY","is-notification-open":"_2KWL","header":"_3TAQ","theme-dark":"_3uJX","theme-gray":"_2__8","is-dropdown-open":"_3sHQ","menu":"_2IVQ","collapse":"_3scO","main-navigation":"_3TmG","navigation":"wixE","buttons-group":"_2fCs","focusable":"VXau","overflow":"_1AGc","login-button":"_2Vg9","login-button--dark":"QN_e","signup-button":"_3POG","menu-mobile":"_1yjk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/WebHeader/WebHeader.styl
// module id = 83
// module chunks = 0